import script from "./Myjobs.vue?vue&type=script&setup=true&lang=js"
export * from "./Myjobs.vue?vue&type=script&setup=true&lang=js"

import "./Myjobs.vue?vue&type=style&index=0&id=368b8e6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-368b8e6f"]])

export default __exports__